import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1934 4.20983C20.7678 4.59277 20.923 5.36885 20.5401 5.94326L11.5401 19.4433C11.3323 19.7549 10.9958 19.9569 10.6232 19.9938C10.2505 20.0307 9.88092 19.8986 9.61612 19.6338L3.61612 13.6338C3.12796 13.1456 3.12796 12.3542 3.61612 11.866C4.10427 11.3779 4.89573 11.3779 5.38388 11.866L10.3057 16.7878L18.4599 4.55651C18.8429 3.9821 19.619 3.82689 20.1934 4.20983Z"
        fill={colorValue}
      />
    </svg>
  );
};
